var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgAddCustomApp = function SvgAddCustomApp(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 80,
    viewBox: "0 0 89 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M45.898 0c22.09 0 40 17.909 40 40 0 22.09-17.91 40-40 40-22.091 0-40-17.91-40-40 0-22.091 17.909-40 40-40Z",
    className: "illustration-background-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.359 28.673h-6.6A6.086 6.086 0 0 0 .672 34.76v6.6a6.087 6.087 0 0 0 6.087 6.088h6.6a6.088 6.088 0 0 0 6.087-6.087v-6.6a6.086 6.086 0 0 0-6.087-6.087m0 3.478a2.611 2.611 0 0 1 2.609 2.609v6.6a2.612 2.612 0 0 1-2.609 2.609h-6.6a2.612 2.612 0 0 1-2.609-2.61v-6.6a2.61 2.61 0 0 1 2.609-2.608h6.6Zm19.642-3.479h-.035c-5.174 0-9.37 4.195-9.37 9.369v.035c0 5.176 4.195 9.37 9.37 9.37H33a9.37 9.37 0 0 0 9.37-9.37v-.034a9.37 9.37 0 0 0-9.37-9.37m0 3.478c3.248 0 5.891 2.644 5.891 5.926 0 3.25-2.643 5.893-5.927 5.893-3.248 0-5.89-2.644-5.89-5.928a5.898 5.898 0 0 1 5.89-5.89h.036m3.305 19.468h-6.602a6.087 6.087 0 0 0-6.087 6.087v6.6a6.086 6.086 0 0 0 6.087 6.087h6.6a6.086 6.086 0 0 0 6.087-6.087v-6.6a6.086 6.086 0 0 0-6.087-6.087m0 3.478c1.44 0 2.609 1.17 2.609 2.609v6.6a2.611 2.611 0 0 1-2.609 2.609h-6.6a2.612 2.612 0 0 1-2.608-2.609v-6.6a2.612 2.612 0 0 1 2.608-2.609h6.6ZM18.847 69.803l-.005.005a2.006 2.006 0 0 1-2.828 0L1.234 55.03a2.006 2.006 0 0 1 0-2.828l.006-.005a2.004 2.004 0 0 1 2.828 0l14.779 14.777c.778.778.778 2.05 0 2.828",
    className: "illustration-light-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1.235 69.803.006.005c.777.777 2.05.777 2.827 0l14.779-14.779a2.006 2.006 0 0 0 0-2.827l-.006-.005a2.004 2.004 0 0 0-2.827 0L1.234 66.974a2.004 2.004 0 0 0 0 2.828",
    className: "illustration-light-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.114 13.9h20.87M21.548 24.333V3.464",
    className: "illustration-main-stroke",
    stroke: "#121312",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M43.017 59.125a4.951 4.951 0 0 1-4.946-4.945V22.33a4.95 4.95 0 0 1 4.946-4.945H81.82a4.952 4.952 0 0 1 4.946 4.945v31.85a4.952 4.952 0 0 1-4.946 4.944H43.017v.001Z",
    className: "illustration-background-fill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M81.82 15.647H43.018a6.684 6.684 0 0 0-6.686 6.684V54.18a6.684 6.684 0 0 0 6.685 6.684h38.805a6.684 6.684 0 0 0 6.684-6.684V22.33a6.684 6.684 0 0 0-6.684-6.684m0 3.478a3.21 3.21 0 0 1 3.207 3.206v31.85a3.21 3.21 0 0 1-3.207 3.205H43.017a3.21 3.21 0 0 1-3.207-3.206V22.33a3.21 3.21 0 0 1 3.206-3.206h38.805Z",
    className: "illustration-light-fill"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.405 29.546h46.087",
    className: "illustration-light-stroke",
    stroke: "#A1A3A7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M45.898 23.458a1.74 1.74 0 1 1-3.48-.001 1.74 1.74 0 0 1 3.48.001Zm6.065 0a1.74 1.74 0 1 1-3.48-.001 1.74 1.74 0 0 1 3.48.001Zm6.101 0a1.74 1.74 0 1 1-3.48-.001 1.74 1.74 0 0 1 3.48.001Z",
    className: "illustration-light-fill"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m58.072 52.154-7.826-7.826 7.826-7.826m8.681 15.652 7.826-7.826-7.826-7.826",
    className: "illustration-light-stroke",
    stroke: "#A1A3A7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgAddCustomApp;